import script from "./NotaDebit.vue?vue&type=script&setup=true&lang=js"
export * from "./NotaDebit.vue?vue&type=script&setup=true&lang=js"

import "./NotaDebit.vue?vue&type=style&index=0&id=5ec10b64&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ec10b64"]])

export default __exports__